import { FC } from 'react';
import { IconInfoRegular } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Drawer } from '@common/overlay-manager';
import { Typography } from '@common/styles';
import { BeautyIngredientSummary, BeautyOneLineReview, TouchAccessibilityWrapper } from '@domains/pdp-common';

import { IngredientInfoView } from '../components/popup';
import { IngredientDescription, OneLineReview } from '../components/summary';
import { useBeautyService } from '../services/useBeautyService';

export const BeautySummaryContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const {
    ingredientSummary: summary,
    oneLineReview,
    ingredientInfoOpen,
    handleIngredientInfoPopup,
  } = useBeautyService();

  if (isHideBeautySummary(summary, oneLineReview)) {
    return null;
  }

  return (
    <Root>
      <Title>
        <p className={Typography.BODY_18_SEMIBOLD}>한 눈에 상품 요약</p>
        <TouchAccessibilityWrapper touchWidth={40} touchHeight={40} onClick={() => handleIngredientInfoPopup(true)}>
          <IconInfoRegular size={24} color='textTertiary' />
        </TouchAccessibilityWrapper>
      </Title>
      {summary && <IngredientDescription summary={summary} />}
      {oneLineReview && <OneLineReview oneLineReview={oneLineReview} />}
      <Drawer height='auto' open={ingredientInfoOpen} onClose={() => handleIngredientInfoPopup(false)}>
        <IngredientInfoView />
      </Drawer>
    </Root>
  );
};

function isHideBeautySummary(summary: BeautyIngredientSummary | null, oneLineReview: BeautyOneLineReview | null) {
  if (!summary && !oneLineReview) {
    return true;
  }

  const hasPrimary = summary ? summary.primary_description_list.length > 0 : false;
  const hasWarning = summary ? summary.warning_description_list.length > 0 : false;
  const hasOrdererAttribute = oneLineReview ? oneLineReview.orderer_attribute_list.length > 0 : false;
  const hasMostAnsweredReview = oneLineReview ? !!oneLineReview.most_answered_review_question : false;

  if (!hasPrimary && !hasWarning && !hasOrdererAttribute && !hasMostAnsweredReview) {
    return true;
  }

  return false;
}

const Root = styled.section`
  padding: 8px 16px;
  border-top: 8px solid ${vars.v3Color.gray100};
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;

  p {
    color: ${vars.v3Color.gray900};
    padding: 12px 0;
  }
`;
